<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <!-- <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour> -->
                            <h4 class="card-title">Pedido</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip.hover.left="'Cadastrar'" v-if="getPermission('pedido.store')"><i class="ft-plus"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Pedidos" v-if="getPermission('pedido.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Cancelar Pedidos" v-if="getPermission('pedido.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="onShowHelp()" v-b-tooltip title="Ajuda"><i class="ft-help-circle"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/pedido"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="pedido_id"
                                            pagination-path=""
                                            detail-row-component="pedido-detalhes"
                                            @vuetable:cell-clicked="onDetail"
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>

                                          </template>
                                          <template slot="pessoa" slot-scope="props">
                                              <span>{{ onFormataCnpj(props.rowData.pessoa_tomador.pessoa_juridica.cnpj_base,props.rowData.pessoa_tomador.pessoa_juridica.cnpj_filial,props.rowData.pessoa_tomador.pessoa_juridica.cnpj_digito)}} - {{ props.rowData.pessoa_tomador.pessoa_juridica.razao_social }}</span>
                                          </template>
                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermission('pedido.update')&&props.rowData.status.valor==2"><i class="fa fa-edit"></i></a>
                                                <span v-if="getPermission('pedido.status')">
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(3, props.rowData, true)" v-b-tooltip title="Cancelar"><i class="fa fa-times"></i></a>
                                                    <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(3, props.rowData, true)" v-b-tooltip title="Cancelar"><i class="fa fa-times"></i></a>
                                                </span>
                                                <a @click="onCreateUc(props.rowData, props.rowIndex)" v-b-tooltip title="Adicionar Unidade Carga"  v-if="getPermission('pedido.store')&&(props.rowData.permite_adicionar_uc.valor==1)&&(props.rowData.status.valor!=3)"><i class="fa fa-ship"></i></a>
                                                <a @click="onDuplicarPedido(props.rowData, props.rowIndex)" v-b-tooltip title="Duplicar pedido"><i class="fa fa-refresh"></i></a>
                                                <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                              </button>
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_help"
                     ref="modal_help"
                     :title="modal_titulo"
                     close-title="Fechar"
                     v-model="showModalHelp"
                     size="lg">
                <b-container fluid class="p-a-0">
                    Tags disponíveis para campo observação: <br/>
                    #num_pedido = Número do pedido <br/>
                    #container = Número do container <br/>
                    #lacre = Número do lacre <br/>
                    #peso_bruto = Peso bruto das notas fiscais <br/>
                    #advalorem_percentual = Valor do percentual de Advalorem <br/><br/>
                    Atenção! O campo observação é formado pela Observação do CTE ( Pedido ) + Observação inserida no GRID ( Observação do GRID ).
                </b-container>
            </b-modal>
            <b-modal id="modal_uc"
                       ref="modal_uc"
                       :title="modal_titulo"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       :ok-disabled=formuc.errors.any()
                       v-model="showModalUc"
                       @ok="handleOkUc">
              <form @submit.stop.prevent="handleOkUc" @keydown="formuc.errors.clear($event.target.name)">
                  <b-container fluid class="p-a-0">
                      <b-col>
                          <b-form-input type="text"
                                    placeholder="Unidade Carga"
                                    v-model="formuc.qtde_uc"
                                    >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="formuc.errors.get('qtde_uc')" v-if="formuc.errors.has('qtde_uc')"></b-form-feedback>
                      </b-col>
                  </b-container>
              </form>
              <div slot="modal-footer" class="w-100">
                 <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                    <div class="float-right">
                       <b-btn @click="showModalUc=false" variant="secondary">
                         Fechar
                       </b-btn>
                       <b-btn @click="handleOkUc($event)" variant="secondary" :disabled="isDisabled">
                         Enviar
                       </b-btn>
                   </div>
               </div>
           </b-modal>

           <b-modal id="modal_duplicar"
                      ref="modal_duplicar"
                      :title="modal_titulo"
                      :ok-title="modal_botao"
                      close-title="Fechar"
                      :ok-disabled=formuc.errors.any()
                      v-model="showModalDuplicar"
                      @ok="handleOkDuplicar">
             <form @submit.stop.prevent="handleOkUc" @keydown="form_duplicar.errors.clear($event.target.name)">
                 <b-container fluid class="p-a-0">
                     <b-row>
                         <b-col>
                             <label>Tomador*</label>
                             <multiselect v-model="form_duplicar.tomador"
                             :options-limit="300"
                             :limit="2"
                             :limit-text="limitText"
                             :options="optionsTomador"
                             track-by="value"
                             label="label"
                             :hide-selected="true"
                             placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                             tag-placeholder="Selecionar"
                             select-label="Selecionar"
                             selected-label="Selecionado"
                             deselect-label="Remover"
                             :searchable="true"
                             :loading="isLoadingTom"
                             @search-change="listaClientesTomador"
                             ></multiselect>
                             <b-form-feedback class="text-danger" v-text="form_duplicar.errors.get('tomador.value')" v-if="form_duplicar.errors.has('tomador.value')"></b-form-feedback>
                         </b-col>
                     </b-row>
                     <b-row>
                         <b-col>
                             <label>Qtde UC</label>
                             <b-form-input type="text"
                                       placeholder="Unidade Carga"
                                       v-model="form_duplicar.qtde_uc"
                                       >
                             </b-form-input>
                             <b-form-feedback class="text-danger" v-text="form_duplicar.errors.get('qtde_uc')" v-if="form_duplicar.errors.has('qtde_uc')"></b-form-feedback>
                         </b-col>
                     </b-row>
                     <b-row>
                         <b-col>
                             <label>O pedido será criado e ficará inativo com o Tomador escolhido. Você poderá edita-lo antes de ativar o pedido</label>
                         </b-col>
                     </b-row>
                 </b-container>
             </form>
             <div slot="modal-footer" class="w-100">
                <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                   <div class="float-right">
                      <b-btn @click="showModalDuplicar=false" variant="secondary">
                        Fechar
                      </b-btn>
                      <b-btn @click="handleOkDuplicar($event)" variant="secondary" :disabled="isDisabled">
                        Duplicar
                      </b-btn>
                  </div>
              </div>
          </b-modal>
        </div>
        <PedidoForm
            ref="pedidoform">
        </PedidoForm>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import PedidoFilterBar from './PedidoFilterBar'
import moment from 'moment'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import PedidoForm from '../components/PedidoForm'
import PedidoDetalhes from './PedidoDetalhes'

Vue.component('pedido-detalhes', PedidoDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PedidoForm,
        'vuetable-filterbar': PedidoFilterBar,
        VMoney,
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          isLoadingTom: false,
          isLoadingFor: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showModalUc: false,
          showModalDuplicar: false,
          showModalHelp: false,
          optionsLivStatus: [],
          optionsStatus: [],
          optionsCfop: [],
          optionsParamCst: [],
          optionsPedidoTomador: [],
          optionsMunicipioIni: [],
          optionsMunicipioFim: [],
          optionsLivTpPedido: [],
          optionsLivTpServico: [],
          optionsLivTpCarga: [],
          optionsLivTpFronteira: [],
          optionsLivAdvalorem: [],
          optionsLivTpValorAdvalorem: [],
          optionsLivTpValorCarga: [],
          optionsLivAddUc: [],
          optionsLivImpostoIncluso: [],
          optionsTomador: [],
          optionsFornecedor: [],
          optionsLivStatusTrecho: [],
          optionsLivTpTrecho: [],
          optionsLivTpCusto: [],
          optionsBModal: [],
          optionsLivTpTrechoCusto: [],
          optionsLivStatusTrechoCusto: [],
          optionsLivTpCustoTrecho: [],
          optionsCusto: [],
          optionsLivTpCFrete: [],
          optionsCustoCFrete: [],
          optionsParamRespSeg: [],
          optionsSeguradora: [],
          valor_total_custo_trecho: 0,
          valor_total_custo: 0,
          valor_total_despesa: 0,
          valor_total_receita: 0,
          margem: 0,
          errors_array: [],
          trecho: [ { status: 2,
                     tp_trecho: [],
                     tp_custo: 2,
                     modal: [],
                     municipio_ini: [],
                     municipio_fim: [],
                     principal: 2,
                     ordem: '',
                     pedpartre_id: '',
                     fornecedor: [],
                     tp_trecho_custo: [],
                     advalorem: '',
                     vlr_total_subtrecho: 0,
                     subtrecho: 2,
                     subtrechos: [
                                    { status: 2,
                                        tp_trecho: [],
                                        tp_custo: 2,
                                        modal: [],
                                        municipio_ini: [],
                                        municipio_fim: [],
                                        principal: 2,
                                        ordem: '',
                                        pedpartre_id: '',
                                        tp_trecho_custo: [],
                                        subtrecho: 1,
                                        descr_subtrecho: '',
                                        custo_subtrecho: []
                                     }
                                ],
                     trecho_custo: [ { status: 1,
                                    tp_custo_trecho: [],
                                    descr: '',
                                    valor: 0,
                                    pedpartrc_id: '',
                                    custo: []
                                }],
                  }],
         comp_frete: [ {pedparcfr_id: '',
                    valor: 0,
                    insere_advalorem: 2,
                    custo: [],}],
         seguro: [ { respseg: [],
                    seguradora: [],
                    partprese_id: '',}],
         form: new Form({ descr: '',
                           obs: '',
                           obs_cte: '',
                           obs_cte_fiscal: '',
                           dt_pedido: '',
                           percentual_advalorem: 0,
                           produto_predominante: '',
                           pedido_id: '',
                           qtde_uc: 0,
                           bmodal: [],
                           status: [],
                           cfop: [],
                           cst: [],
                           municipio_ini: [],
                           municipio_fim: [],
                           tp_pedido: [],
                           tp_servico: [],
                           tp_carga: [],
                           tp_fronteira: [],
                           exibe_advalorem_cfrete: [],
                           tp_valor_advalorem: [],
                           tp_valor_carga: [],
                           permite_adicionar_uc: [],
                           imposto_incluso: [],
                           tomador: [],
                           pedido_tomador: [],
                           trecho: [],
                           comp_frete: [],
                           valor_total_receita: 0,
                           margem: 0,
                           custo_receita: [],
                           seguro: [],
                       }),
         formuc: new Form({qtde_uc: '',
                          pedido_id: '',
                 }),
         form_duplicar: new Form({qtde_uc: '',
                          pedido_id: '',
                          tomador: [],
                 }),
         aliquota: {
             decimal: ',',
             prefix: '% ',
             precision: 2,
             masked: false /* doesn't work with directive */
         },
         helpForm: new Form({statusRecord: [], params: [],search:'', status: ''}),
         fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: '__slot:pessoa',
            title: 'CPNJ/Razão Social',
            sortField: 'pessoa'
          },
          {
            name: 'num_pedido',
            title: 'N° Pedido',
            sortField: 'num_pedido'
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: 'dt_pedido',
            title: 'Data do Pedido',
            callback: 'formatDate|DD/MM/YYYY'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },

    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'num_pedido': data_filter.num_pedido,
                'num_uc': data_filter.num_uc,
                'tom_cnpj': data_filter.tom_cnpj,
                'for_cnpj': data_filter.for_cnpj,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim,
                'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.pedido_id);
        },
        classSubtrecho : function(subtrecho){
            if(subtrecho==1)
            {
                return 'table-success';
            }
            else
            {
                return 'table-info';
            }
        },
        onShowHelp() {
            this.modal_titulo = "Ajuda";
            this.modal_acao = "i";
            this.showModalHelp = true;
        },
        handleOkUc(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreUc();
            }
        },
        handleOkDuplicar(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreDuplicar();
            }
        },
        onCreateUc (data, index) {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Vincular Unidade Carga";
            this.modal_botao = "Vincular";
            this.modal_acao = "i";
            this.formuc.reset();
            this.formuc.qtde_uc = '';
            this.formuc.pedido_id = data.pedido_id;
            this.$refs.modal_uc.show();
        },
        onDuplicarPedido (data, index) {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Duplicar pedido";
            this.modal_botao = "Duplicar";
            this.modal_acao = "i";
            this.form_duplicar.reset();
            this.form_duplicar.qtde_uc = '';
            this.form_duplicar.pedido_id = data.pedido_id;
            this.$refs.modal_duplicar.show();
        },
        onStoreUc() {
            this.loading = true;
            this.isDisabled = true;
            this.formuc.post('/api/pedido/store/unidadecarga').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onStoreDuplicar() {
            this.loading = true;
            this.isDisabled = true;
            this.form_duplicar.post('/api/pedido/store/duplicar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getDespesaCusto: function() {
          this.valor_total_custo_trecho = 0;
          this.row_vlr_subtrecho = 0;
          this.trecho.forEach((obj)=>
          {
              obj.trecho_custo.forEach((obj2)=>
              {
                  this.row_vlr = obj2.valor.replace( ".", "" );
                  this.row_vlr = this.row_vlr.replace( ",", "." );
                  this.row_vlr = parseFloat( this.row_vlr.replace(/[^0-9.]/g, "") );

                  if(this.row_vlr!="" && !isNaN(this.row_vlr))
                  {
                      this.valor_total_custo_trecho = parseFloat(this.valor_total_custo_trecho)+parseFloat(this.row_vlr);
                  }
              })

              if(obj.vlr_total_subtrecho!==undefined && obj.vlr_total_subtrecho!="0")
              {
                  this.row_vlr_subtrecho = obj.vlr_total_subtrecho.replace( ".", "" );
                  this.row_vlr_subtrecho = this.row_vlr_subtrecho.replace( ",", "." );
                  this.row_vlr_subtrecho = parseFloat( this.row_vlr_subtrecho.replace(/[^0-9.]/g, "") );
              }

              this.valor_total_custo_trecho = parseFloat(this.valor_total_custo_trecho)+parseFloat(this.row_vlr_subtrecho);
          })
          this.valor_total_despesa = this.formatNumber(parseFloat(this.valor_total_custo_trecho));
        },
        getReceita: function() {
          this.valor_total_receita = 0;
          this.comp_frete.forEach((obj)=>
          {
              this.row_vlr = obj.valor.replace( ".", "" );
              this.row_vlr = this.row_vlr.replace( ",", "." );
              this.row_vlr = parseFloat( this.row_vlr.replace(/[^0-9.]/g, "") );

              if(this.row_vlr!="" && !isNaN(this.row_vlr))
              {
                  this.valor_total_receita = parseFloat(this.valor_total_receita)+parseFloat(this.row_vlr);
              }
          });
          this.form.valor_total_receita = this.formatNumber(parseFloat(this.valor_total_receita));
        },
        getMargemCusto: function(valor) {
              this.form.valor_total_receita = Number((parseFloat(this.valor_total_despesa)/Number((1-(parseFloat(valor)/100)))).toFixed(4)).toFixed(2);
        },
        getMargemCustoReverso: function(valor) {
              this.form.margem = Number(100-Number((Number(parseFloat(this.valor_total_despesa)).toFixed(4)/Number(parseFloat(this.form.valor_total_receita)).toFixed(2))*100).toFixed(4)).toFixed(2);
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatDate (value, fmt = 'DD MM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY/MM/DD').format(fmt)
        },
        getLivGeral() {
            this.helpForm.get('/api/pedido/jsonlistGeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.param_cst.forEach((obj)=>
                {
                    this.optionsParamCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id })
                })
                response.seguradora.forEach((obj)=>
                {
                    this.optionsSeguradora.push({ label: obj.nome, value: obj.segurado_id })
                })
                response.param_resp_seg.forEach((obj)=>
                {
                    this.optionsParamRespSeg.push({ label: obj.descr, value: obj.partprese_id })
                })
                response.municipio.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                })
                response.cfop.forEach((obj)=>
                {
                    this.optionsCfop.push({ label: obj.cd+" - "+obj.descr, value: obj.cfop_id })
                })
                response.status.forEach((obj)=>
                {
                    this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_pedido.forEach((obj)=>
                {
                    this.optionsLivTpPedido.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_servico.forEach((obj)=>
                {
                    this.optionsLivTpServico.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_carga.forEach((obj)=>
                {
                    this.optionsLivTpCarga.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_fronteira.forEach((obj)=>
                {
                    this.optionsLivTpFronteira.push({ label: obj.descr, value: obj.valor })
                })
                response.exibe_advalorem_cfrete.forEach((obj)=>
                {
                    this.optionsLivAdvalorem.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_valor_advalorem.forEach((obj)=>
                {
                    this.optionsLivTpValorAdvalorem.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_valor_carga.forEach((obj)=>
                {
                    this.optionsLivTpValorCarga.push({ label: obj.descr, value: obj.valor })
                })
                response.permite_adicionar_uc.forEach((obj)=>
                {
                    this.optionsLivAddUc.push({ label: obj.descr, value: obj.valor })
                })
                response.imposto_incluso.forEach((obj)=>
                {
                    this.optionsLivImpostoIncluso.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho.forEach((obj)=>
                {
                    this.optionsLivStatusTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.b_modal.forEach((obj)=>
                {
                    this.optionsBModal.push({ label: obj.descr, value: obj.bmodal_id, cd: obj.cd })
                })
                response.tp_trecho.forEach((obj)=>
                {
                    this.optionsLivTpTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo.forEach((obj)=>
                {
                    this.optionsLivTpCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivStatusTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo_trecho.forEach((obj)=>
                {
                    this.optionsLivTpCustoTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.custo.forEach((obj)=>
                {
                    this.optionsCusto.push({ label: obj.descr, value: obj.custo_id })
                })
                response.pedido_tomador.forEach((obj)=>
                {
                    this.optionsPedidoTomador.push({ label: obj.descr, value: obj.valor })
                })
                response.custo.forEach((obj)=>
                {
                    if(obj.is_cfrete==1)
                    {
                        this.optionsCustoCFrete.push({ label: obj.descr, value: obj.custo_id })
                    }
                })
                response.tp_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivTpTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })

            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
          listaClientesFornecedor(search) {
              if(search.length>=3)
              {
                  this.isLoadingFor = true;
                  this.helpForm.search = search;
                  this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
                  {
                      this.optionsFornecedor = [];
                      new ReturnApi(response, this, true, false, false);
                      response.items.forEach((obj)=>
                      {
                          this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                      });
                      this.isLoadingFor = false;
                  })
                  .catch(errors =>
                  {
                      new ReturnApi(errors, this)
                    });
                }
            },
        onActivateDesactivate(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.pedido_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/pedido/status').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });

        },
        onEdit(data, index)     {
            this.$refs.pedidoform.onEdit(data, index);
        },
        onCreate()     {
            this.$refs.pedidoform.onCreate();
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        addRowTrecho: function(e, en_subtrecho) {
            e.preventDefault();
            this.trecho.push({
                ordem: "",
                principal: 2,
                tp_trecho: [],
                tp_trecho_custo: [],
                advalorem: '',
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                subtrecho: en_subtrecho,
                tp_custo: "",
                vlr_total_subtrecho: 0,
                trecho_custo: [],
                subtrechos: [],
            });
        },
        addRowSubTrecho: function(e, row) {
            e.preventDefault();
            row.subtrechos.push({
                ordem: "",
                principal: 2,
                tp_trecho: [],
                tp_trecho_custo: [],
                advalorem: '',
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                tp_custo: "",
                subtrecho: 1,
            });
        },
        removeRowTrecho: function(index) {
            this.trecho.splice(index, 1);
            this.getDespesaCusto()
        },
        removeRowSubTrecho: function(row, index) {
            row.subtrechos.splice(index, 1);
            if(row.subtrechos.length==0)
            {
                row.vlr_total_subtrecho = 0;
            }
            this.getDespesaCusto();
        },
        addRowTrechoCusto: function(e, row, index) {
            e.preventDefault();
            this.trecho[index].trecho_custo.push({
                valor: "",
                descr: "",
                tp_custo_trecho: [],
                custo: [],
            });
        },
        removeRowTrechoCusto: function(row,index) {
            row.trecho_custo.splice(index, 1);
            this.getDespesaCusto();
        },
        addRowSeguro: function(e) {
            e.preventDefault();
            this.seguro.push({
                seguradora: [],
                respseg: [],
            });
        },
        removeRowSeguro: function(index) {
            this.seguro.splice(index, 1);
        },
        addRowCompFrete: function(e) {
            e.preventDefault();
            this.comp_frete.push({
              valor: "",
              insere_advalorem: 2,
              custo: [],
            });
        },
        removeRowCompFrete: function(index) {
            this.comp_frete.splice(index, 1);
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
